/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import * as consts from '../../../const';
import ReportsComponent from './reports.component';
import { showModal } from '../../../actions/actions';
import {
  clearCSV,
  fetchAccessRigthsChangesCSV,
  fetchStudyPersonnelReportCVS
} from '../../../actions/study.details.actions';
import { MODAL_TYPE_ALL_SITES_REPORTS, MODAL_TYPE_PARTICIPANT_ARCHIVE } from '../../../constants/modalTypes';
import { path } from 'ramda';

export const mapStateToProps = (state, ownProps) => {
  return {
    sites: state.organizations,
    study: state.subject.participantStudy,
    topic: state.menu.topic,
    sponsor: state.sponsor.selectedSponsor,
    user: state.login.user,
    isExportInitiated: state.reports.initiatedParticipantExport,
    userAssignment: path(['rolemanagement', 'loggedUser'], state)
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showAllReports: (sites) => {
      dispatch(
        showModal(MODAL_TYPE_ALL_SITES_REPORTS, {
          title: consts.REPORTS_MODAL_TITLE,
          shouldCloseOnOverlayClick: false,
          className: 'all-reports-modal tc-modal tc-modal-med',
          sites: sites
        })
      );
    },
    downloadStudyPersonelCSV: (sponsorGid, studyGid) => dispatch(fetchStudyPersonnelReportCVS(sponsorGid, studyGid)),
    clearCSV: () => {
      dispatch(clearCSV());
    },
    downloadAccessLogCSV: (studyGid, payload) => dispatch(fetchAccessRigthsChangesCSV(studyGid, payload)),
    showExportParticipantArchiveMenu: (study) => {
      dispatch(
        showModal(MODAL_TYPE_PARTICIPANT_ARCHIVE, {
          title: consts.PARTICIPANT_ARCHIVE_TITLE,
          subtitle: study.name,
          shouldCloseOnOverlayClick: false,
          className: 'all-reports-modal tc-modal tc-modal-med'
        })
      );
    }
  };
};

const ReportsContainer = connect(mapStateToProps, mapDispatchToProps)(ReportsComponent);

export default ReportsContainer;
